import React from "react";
import { pipe } from "fp-ts/function";
import * as R from "fp-ts/Record";
import * as A from "fp-ts/Array";
import * as O from "fp-ts/Option";

import { Separator } from "src/components/separator/separator";
import { Body, PageTitle, SectionTitle } from "src/components/typography/typography";
import { DomainsCircle } from "../../graphics/domains_circle";
import { meta } from "../../../v1/sections/head/meta";
import { BarChart } from "../../../../../../components/charts/bar_chart";
import { isNotNil } from "../../../../../../utils/type_guards";

/*
 * Types
 */

export type HeadProps = {
    readonly reports: Array<any>;
};

/*
 * Main
 */

export const Head = (props: HeadProps): React.ReactElement => {
    const { reports } = props;

    return (
        <div className="main-report-content-wrap">
            <div className="single-domain-result-top-wrap">
                <DomainsCircle activeDomain="head" inline />
                <PageTitle style={{ color: "#99b84e" }}>Head</PageTitle>
                <Body>
                    While the 25-item propositional survey was not validated by factor analysis, preliminary analysis
                    lends substantial face validity to the Head domain: students enrolled in their Christian school for
                    more years were more likely to assent to survey items than students enrolled for just a few years,
                    and respondents who self-reported being a Christian “for many years” were more likely to assent than
                    those who were unsure or knew that they were not a Christian.
                </Body>
                <Body>
                    For “Head” items: <br />
                    <br />
                    1 = Strongly Disagree <br />
                    2 = Disagree <br />
                    3 = Neutral <br />
                    4 = Agree <br />5 = Strongly Agree
                </Body>
                <Separator />
            </div>
            {pipe(
                R.keys(reports[0].node.results.raw.head),
                A.map((construct) => (
                    <div className="an-opportunity-item domain-result" key={construct}>
                        {pipe(
                            R.lookup(construct, meta),
                            O.map((m) => (
                                <>
                                    <SectionTitle style={{ color: "#99b84e" }}>{m.title}</SectionTitle>
                                    <Body>{m.prologue}</Body>
                                    <BarChart
                                        backgroundColor="#99b94e"
                                        data={reports.flatMap((report) => {
                                            return [
                                                {
                                                    label: `${report.node.year} - Parents`,
                                                    value: report.node.results.raw.head[construct].parents,
                                                },
                                                {
                                                    label: `${report.node.year} - Board Members, Admins, Teachers, Staff`,
                                                    value: report.node.results.raw.head[construct]
                                                        .boardAdminsTeachersStaff,
                                                },
                                                {
                                                    label: `${report.node.year} - Students, Alumni`,
                                                    value: report.node.results.raw.head[construct].studentsAlumni,
                                                },
                                            ];
                                        })}
                                        isRaw={true}
                                        maxValue={5}
                                    />
                                    {isNotNil(m.extra) && <Body className="small-domain-text">{m.extra}</Body>}
                                </>
                            )),
                            O.getOrElse(() => <></>),
                        )}
                    </div>
                )),
            )}
        </div>
    );
};
